import { UserSettingEditPage } from "@/features/user-setting/pages/UserSettingEditPage";

const UserSettingEdit = () => {
  return <UserSettingEditPage />;
};

export default UserSettingEdit;
